import React from "react";
import { stringify, parse } from "qs";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

import TextInput from "components/library/TextInput";
import styles from "./SearchBar.css";

class SearchBar extends React.Component {
  // TODO: handle on load and refresh

  constructor(props) {
    super(props);
    this.state = {
      query: "",
      isOnSearchPage: this.props.location.pathname.includes("search"),
    };

    this.handleFormSubmit = this._handleFormSubmit.bind(this);
    this.activateSearchResults = this._activateSearchResults.bind(this);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    this.activateSearchResults();
  }

  UNSAFE_componentWillMount() {
    if (this.props.location.search) {
      const term = parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      }).q;
      this.setState({ query: term });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({
        isOnSearchPage: nextProps.location.pathname.includes("search"),
      });
    }
  }

  _activateSearchResults() {
    const searchRoute = `/dashboard/search/?${stringify({
      q: this.state.query,
    })}`;
    if (this.state.isOnSearchPage) {
      this.props.history.replace(searchRoute);
    } else {
      this.props.history.push(searchRoute);
    }
  }

  render() {
    return (
      <form className={styles.root} onSubmit={this.handleFormSubmit}>
        <TextInput
          autoFocus={this.state.isOnSearchPage ? false : true}
          type="search"
          className={styles.input}
          value={this.state.query}
          placeholder="Search stories, people and more..."
          onChange={e => {
            this.setState({ query: e.target.value });
          }}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />
      </form>
    );
  }
}

SearchBar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default withRouter(SearchBar);
